export const LOCAL_PACK_SEARCH_PHRASE_ANALYTICS_KEY = 'localPackLeaderboard';
